import axios from 'axios';
import { createHeaders, withReThrowingDataServiceError, } from './data-service-api';
export class DataServiceWalletDappAddressesApiClient {
    constructor(baseUrl, tokenProvider) {
        this.baseUrl = baseUrl;
        this.tokenProvider = tokenProvider;
    }
    async create(command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/wallets/me/dappAddresses`, command, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async delete(dappAddressId) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .delete(`${this.baseUrl}/api/v1/wallets/me/dappAddresses/${dappAddressId}`, {
            headers: createHeaders(token),
        })
            .then());
    }
    async find(dappAddressId) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/wallets/me/dappAddresses/${dappAddressId}`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async findAll(query) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/wallets/me/dappAddresses`, {
            headers: createHeaders(token),
            ...(query && { params: query }),
        })
            .then((it) => it.data));
    }
    async patch(dappAddressId, command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .patch(`${this.baseUrl}/api/v1/wallets/me/dappAddresses/${dappAddressId}`, command, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
}
//# sourceMappingURL=data-service-wallet-dapp-addresses-api.js.map